// extracted by mini-css-extract-plugin
module.exports = {"cover":"Loader_cover__7t5p4","loading":"Loader_loading__nE5Wp","ldsDualRing":"Loader_ldsDualRing__EgXdl"};